import Image from 'next/image'
import { getReadableImageUrl } from "@/lib/directus";
import { sanitizeHTML } from "@/lib/utils";

interface TransportationData {
  heading?: {
    text?: string;
    title?: string;
  };
  subheading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  logos?: {
    images_id: {
      alt: string;
      image_file: {
        image: {
          id: string;
          filename_download: string;
        };
      };
    };
  }[];
}

export const fields = [
  // headings
  "heading.text",
  "heading.title",

  "subheading.text",
  "subheading.title",

  // text
  "text.text",

  // logos (images)
  "logos.images_id.alt",
  "logos.images_id.image_file.image.id",
  "logos.images_id.image_file.image.filename_download",
] as const;

interface TransportationProps {
  data?: TransportationData;
}

export default function Transportation({ data }: TransportationProps) {
  return (
    <section className="bg-[#8a9bb5] w-full">
      <div className="container mx-auto px-8 lg:px-32 py-16 lg:py-20">
        {/* Main Content Container */}
        <div className="flex flex-col gap-6 md:gap-9">
          {/* Title */}
          <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-white">
            {data?.heading?.text || data?.heading?.title}
          </h2>

          {/* Content Grid */}
          <div className="flex flex-col md:flex-row gap-5 md:gap-20">
            {/* Left Column */}
            <div className="flex flex-col gap-6 md:w-1/2">
              <p className="text-[1rem] font-normal leading-normal lg:text-xl font-greycliff lg:font-medium text-white">
                {data?.subheading?.text || data?.subheading?.title}
              </p>

              {/* Logos Container */}
              <div className="flex items-center gap-5 md:gap-10">
                {data?.logos?.map((logo, index) => (
                  <div key={index} className={index === 0 ? "w-[10.75rem] md:w-[19.375rem]" : "w-[7.75rem] md:w-[15.625rem] p-2"}>
                    <Image
                      src={logo.images_id.image_file.image.id && logo.images_id.image_file.image.filename_download ? getReadableImageUrl(
                        logo.images_id.image_file.image.id,
                        logo.images_id.image_file.image.filename_download
                      ) : "/images/award.png"}
                      alt={logo.images_id.alt}
                      width={index === 0 ? 310 : 250}
                      height={index === 0 ? 108 : 166}
                      quality={90}
                      className="w-full h-auto"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column */}
            <div className="flex flex-col gap-6 md:w-1/2">
              <div 
                className="text-[1rem] font-normal leading-normal md:text-lg font-greycliff text-white md:leading-relaxed [&>p]:mb-4 [&>p:last-child]:mb-0"
                dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || "")}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
} 